const data = {
  data: [
    {
      idUsuario: 1,
      Cliente: 'ClientePrueba',
      Usuario: 'carlos.santos',
      Email: 'carlos.santos@zerocoma.com',
      Rol: 4,
      TipoAutenticacion: 1,
      Grupos: [{ IdGrupo: 2, Nombre: 'GrupoPrueba2', idTipo: 2, Tipo: 'Gestión', Propietario: false }],
      EstadosFacturas: [],
      VerTodoEstados: false,
      VerTodoEmpresas: true,
      idCliente: 1,
    },
    {
      idUsuario: 2,
      Cliente: 'ClientePrueba',
      Usuario: 'ramon.garcia',
      Email: 'ramon.garcia@zerocoma.com',
      Rol: 2,
      TipoAutenticacion: 3,
      Grupos: [{ IdGrupo: 3, Nombre: 'GrupoPrueba3', idTipo: 2, Tipo: 'Gestión', Propietario: true }],
      EstadosFacturas: [],
      VerTodoEstados: false,
      VerTodoEmpresas: true,
      idCliente: 1,
    },
    {
      idUsuario: 3,
      Cliente: 'ClientePrueba',
      Usuario: 'eusebio.gomez',
      Email: 'eusebio.gomez@zerocoma.com',
      Rol: 3,
      TipoAutenticacion: 3,
      Grupos: [{ IdGrupo: 1, Nombre: 'Gestor Facturas', idTipo: 1, Tipo: 'Gestor Facturas', Propietario: false }],
      EstadosFacturas: [],
      VerTodoEstados: true,
      VerTodoEmpresas: true,
      idCliente: 1,
    }
  ],
  links: {
    first: 'http://localhost/api/v1/businesses?page=1',
    last: 'http://localhost/api/v1/businesses?page=3',
    prev: null,
    next: 'http://localhost/api/v1/businesses?page=2'
  },
  meta: {
    current_page: 1,
    from: 1,
    last_page: 3,
    links: [
      {
        url: null,
        label: '&laquo; Anterior',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=1',
        label: '1',
        active: true
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: '2',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=3',
        label: '3',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: 'Siguiente &raquo;',
        active: false
      }
    ],
    path: 'http://localhost/api/v1/businesses',
    per_page: 20,
    to: 20,
    total: 41,
    search: {}
  }
}

export default data
